import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Types
export interface AnalyticEntry {
  id: number;
  campaignPostId: string;
  platform: string;
  date: string;
  impressions: number;
  reach: number;
  clicks: number;
  likes: number;
  comments: number;
  shares: number;
  videoViews: number;
  opens: number;
  extraMetrics: {
    post_clicks_by_type?: Record<string, number>;
    post_reactions_by_type_total?: Record<string, number>;
    profile_activity?: number;
    saved?: number;
    [key: string]: any;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CampaignInfo {
  campaignPostId: string;
  campaignName: string;
  flyerUrl: string;
  validFrom: string;
  validTo: string;
}

export interface CampaignWithAnalytics {
  campaign: CampaignInfo;
  analytics: {
    facebook?: AnalyticEntry[];
    instagram?: AnalyticEntry[];
    [key: string]: AnalyticEntry[] | undefined;
  };
}

export interface CampaignPostsAnalyticsState {
  data: CampaignWithAnalytics[];
  loading: boolean;
  error: string | null;
}

const initialState: CampaignPostsAnalyticsState = {
  data: [],
  loading: false,
  error: null
};

const campaignPostsAnalyticsSlice = createSlice({
  name: 'campaignPostsAnalytics',
  initialState,
  reducers: {
    fetchCampaignPostsAnalyticsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCampaignPostsAnalyticsSuccess: (state, action: PayloadAction<CampaignWithAnalytics[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchCampaignPostsAnalyticsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCampaignPostsAnalytics: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  fetchCampaignPostsAnalyticsRequest,
  fetchCampaignPostsAnalyticsSuccess,
  fetchCampaignPostsAnalyticsFailure,
  clearCampaignPostsAnalytics
} = campaignPostsAnalyticsSlice.actions;

export default campaignPostsAnalyticsSlice.reducer;
